// MIDAS V3 — <cond-info text="…"/> grammar (MIDAS-ANSWER-FORMAT-1 round 6 §(e),
// bot request MACHINEID_TODO.md 2026-10-06 "round 6" (e), lines ~14360-14375;
// spec IMPLEMENTATION_TEMPLATES/ToDo/MidasChat/MIDAS_ANSWER_FORMAT_R6_SPEC.md §4;
// Security review 2026-10-06, SEC-REQ-CI-1 … CI-8).
//
// Wire format (minted by the bot's formatter, never by the model; final
// `answer` event only; at most one per row; at the END of a body row's
// CONDITION cell of the Variant E status table):
//   Pripravenosť regulátora 611D <cond-info text="Hlásenie … opak."/>
//
// CLOSED grammar, fail-closed (SEC-REQ-CI-1): the VOID form only, exactly one
// non-empty `text` attribute. Anything else — paired / open-only form, a
// missing, empty, duplicate or extra attribute — never matches or is
// rejected, and the caller leaves the tag VERBATIM (react-markdown 9 renders
// raw HTML as visible text), so a bot bug stays visible and reportable.
//
// The attribute value is entity-decoded exactly ONCE by markdownComponentsV3's
// readAttr (BUG 12 single-decode rule, SEC-REQ-CI-2) and handed to
// validateCondInfoText below. Nothing here decodes.
//
// Pure — no React, no DOM.

/** Self-closing only (optional whitespace before `/>`). The `([^>]*?)` blob is
 *  validated afterwards with isClosedAttrBlob(blob, COND_INFO_ATTRS). Used
 *  with String.replace only (global flag → never call .test/.exec on it). */
export const COND_INFO_TAG_RE = /<cond-info\b([^>]*?)\/>/gi;

/** The only attribute `<cond-info>` may carry. */
export const COND_INFO_ATTRS = ["text"];

/** Bot limit (Python `len` = code points), enforced on the client too. */
export const COND_INFO_MAX_CHARS = 240;

// SEC-REQ-CI-4: any C0 control (incl. TAB / LF / CR — the contract is "one
// line"), DEL, or C1 control rejects the tag. Checked on the DECODED value,
// BEFORE whitespace is collapsed, so an entity-encoded `&#10;` cannot slip
// through as an innocent space.
// eslint-disable-next-line no-control-regex
const CONTROL_CHAR_RE = /[\u0000-\u001F\u007F-\u009F]/;

// SEC-REQ-CI-4 (optional, taken): bidi embedding / override / isolate
// controls can visually reorder the sentence; they carry no meaning in a
// plain-text explanation, so they are removed rather than rejected.
const BIDI_CONTROL_RE = /[‪-‮⁦-⁩]/g;

/**
 * Normalise + validate a DECODED `text` value. Returns the text to show, or
 * null → the caller leaves the tag verbatim. Rules (SEC-REQ-CI-4, spec §4.2):
 *   • undefined (no attribute) → null
 *   • any C0 / DEL / C1 control character → null
 *   • bidi controls stripped, `\s+` collapsed to one space, trimmed
 *   • empty after that → null
 *   • more than COND_INFO_MAX_CHARS code points → null
 * `<`, `>`, `"`, `|`, `[`, `]` and backticks are NOT rejection reasons: the
 * value is only ever rendered as a React text child (SEC-REQ-CI-3), where a
 * decoded `<img …>` is inert text.
 */
export const validateCondInfoText = (decoded: string | undefined): string | null => {
  if (decoded === undefined) return null;
  if (CONTROL_CHAR_RE.test(decoded)) return null;
  const text = decoded.replace(BIDI_CONTROL_RE, "").replace(/\s+/g, " ").trim();
  if (text === "") return null;
  if (Array.from(text).length > COND_INFO_MAX_CHARS) return null;
  return text;
};
